export const defaultPhoneProps = {
    mode: "international",
    defaultCountry: "BE",
    disabledFetchingCountry: false,
    disabled: false,
    disabledFormatting: false,
    inputOptions: {
        showDialCode: true,
    },
    enabledCountryCode: true,
    enabledFlags: true,
    required: true,
    maxLen: 25,
    autocomplete: "off",
    preferredCountries: ["US", "GB", "BE", "NL", "DE", "FR", "IT", "ES"],
    millisecondsPerDay: 1000 * 60 * 60 * 24,
    epochStart: new Date("1970-01-01").getTime(),
    validCountryCodes: ["+1", "+44", "+32", "+31", "+49"],
};
